module.exports = __webpack_public_path__ + "static/img/const-content-6.e90713c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/const-content-6.png
// module id = Y8SE
// module chunks = 0